import i18next from "i18next"
import { List } from "immutable"
import * as React from "react"
import { any, fromJSX, Unit, Widget } from "widgets-for-react"
import { StyleguideExample, StyleguidePart } from "../../utils/renderers"

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------  STYLEGUIDE RENDERER  ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ObjectsBreadcrumbs = (): Widget<Unit> =>
  any<Unit>([
    StyleguidePart({ title: 'Default', intro: '' })(
      StyleguideExample({ showExampleLabel: false, isFullScreen: false })(
        fromJSX((_) => FakeBreadcrumbs())
      )
    )
  ])

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------  SNIPPETS  ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

type BreadcrumbItemProps = {
  label: string,
  url: string
}

type BreadcrumbProps = {
  items: List<BreadcrumbItemProps>
}

const BreadcrumbLayout = (p: BreadcrumbProps) => {
  return (
    <nav className="breadcrumb" aria-label={i18next.t('a11y:labelBreadcrumbs')}>
      <ul className="breadcrumb__list">
        {p.items.map((item, i, items) => {
          return (
            <li className="breadcrumb__item" key={item.url}>
              {item == items.last()
                ? <span className='breadcrumb__current label--m' aria-current="location">{item.label}</span>
                : <a
                  href={item.url}
                  className='breadcrumb__link label--m'
                >
                  <span className="breadcrumb__label">{item.label}</span>
                </a>
              }
            </li>
          )
        })}
      </ul>
    </nav>
  )
}


export const FakeBreadcrumbs = (list?: List<BreadcrumbItemProps>) => (
  BreadcrumbLayout({
    items: list ? list : List([
      { url: '/', label: 'Evofenedex' },
      { url: '/', label: 'Kennis' },
      { url: '/', label: 'Transport' },
    ])
  })
)
